module.exports = __webpack_public_path__ + "static/media/1 42 hos.3040270d.mp3";